export default __webpack_public_path__ + "images/DEEPECHO logo.1b1519669a719f94e73253dd0cf0f2ad.png";